import clsx from 'clsx';
import React from 'react';

import IconButton from '../../../../atoms/iconButton/IconButton';
import {
  BinDeleteEmpty,
  BinDeleteStrike2,
} from '../../../../atoms/icons';
import styles from '../CartItem.module.scss';

const RemoveButton = ({
  removeFromCart,
  uniqueId,
  placement = 'cart',
  item,
  fill,
}) => {
  return (
    <div
      className={clsx(
        styles.removeButton,
        styles[`removeButton__${placement}`],
      )}
    >
      <IconButton
        data-delete-button={placement}
        color="primary"
        iconRegular={() => <BinDeleteEmpty fill={fill} />}
        iconHover={() => <BinDeleteStrike2 fill={fill} />}
        iconActive={() => <BinDeleteStrike2 fill={fill} />}
        onClick={() => removeFromCart(uniqueId, item)}
      />
    </div>
  );
};

export default RemoveButton;
